const runtimeBrand = (typeof window !== "undefined" && window.PURCHASE_BRAND_CONFIG) || {}

const BRAND = {
  companyKey: runtimeBrand.companyKey || "default",
  companyName: runtimeBrand.companyName || "企业",
  systemName: runtimeBrand.systemName || "商品进销存系统",
  loginTitle: runtimeBrand.loginTitle || "商品进销存系统",
  sidebarTitle: runtimeBrand.sidebarTitle || "进销存管理系统",
  sidebarShortTitle: runtimeBrand.sidebarShortTitle || "进销存",
  welcomeTitle: runtimeBrand.welcomeTitle || "欢迎使用商品进销存系统",
  faviconUrl: runtimeBrand.faviconUrl || "static/logo-default.svg",
  logoUrl: runtimeBrand.logoUrl || "static/logo-default.svg",
  sidebarLogoUrl: runtimeBrand.sidebarLogoUrl || runtimeBrand.logoUrl || "static/logo-default.svg",
  primaryColor: runtimeBrand.primaryColor || "#2f6fed",
};

export default BRAND



// WEBPACK FOOTER //
// ./src/config/brand.js